import * as types from "./dashboardActionTypes";

export function loadSecurityAlertsForLastMonth() {
    return { type: types.LOAD_SECURITY_ALERTS_FOR_LAST_MONTH };
}

export function loadSecurityAlertsLastMonthSuccess(securityAlertsLastMonth) {
    return { type: types.LOAD_SECURITY_ALERTS_LAST_MONTH_SUCCESS, securityAlertsLastMonth };
}

export function loadSecurityAlertsForLastMonthFailed(message) {
    return { type: types.LOAD_SECIURITY_ALERTS_LAST_MONTH_FAILED, message };
}

export function loadSecurityAlertsLastWeekSuccess(securityAlertsLastWeek) {
    return { type: types.LOAD_SECURITY_ALERTS_LAST_WEEK_SUCCESS, securityAlertsLastWeek };
}

export function loadSecurityAlertsForLastWeekFailed(message) {
    return { type: types.LOAD_SECURITY_ALERTS_FOR_LAST_WEEK_FAILED, message };
}

export function loadSecurityAlertsLastWeek() {
    return { type: types.LOAD_SECURITY_ALERTS_LAST_WEEK };
}

export function loadIncidentsSuccess(incidents) {
    return { type: types.LOAD_INCIDENTS_SUCCESS, incidents };
}

export function loadIncidentsFailed(message) {
    return { type: types.LOAD_INCIDENTS_FAILED, message };
}

export function loadIncidents() {
    return { type: types.LOAD_INCIDENTS };
}

export function loadSystemStatusSuccess(systemStatus) {
    return { type: types.LOAD_SYSTEM_STATUS_SUCCESS, systemStatus };
}

export function loadSystemStatusFailed(message) {
    return { type: types.LOAD_SYSTEM_STATUS_FAILED, message };
}

export function loadSystemStatus() {
    return { type: types.LOAD_SYSTEM_STATUS };
}

export function loadDeviceGroupsFailed(message) {
    return { type: types.LOAD_DEVICE_GROUPS_FAILED, message };
}

export function loadDeviceGroupsSuccess(deviceGroups) {
    return { type: types.LOAD_DEVICE_GROUPS_SUCCESS, deviceGroups };
}

export function loadDeviceGroups() {
    return { type: types.LOAD_DEVICE_GROUPS };
}

export function loadLogsPerDaySuccess(logsPerDay) {
    return { type: types.LOAD_LOGS_PER_DAY_SUCCESS, logsPerDay };
}

export function loadLogsPerDayFailed(message) {
    return { type: types.LOAD_LOGS_PER_DAY_FAILED, message };
}

export function loadLogsPerDay() {
    return { type: types.LOAD_LOGS_PER_DAY };
}


// WEBPACK FOOTER //
// ./src/dashboard/dashboardActions.js